import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";

import Breadcrumb from "../../components/Breadcrumb";

import AllBookingLayer from "../../components/booking/AllBookingLayer";




const AllBookingPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb routePath="/all-bookings" routeName="Home" title="All Bookings" />

        {/* TableDataLayer */}
        <AllBookingLayer/>
        {/* <AlertLayer/> */}
    

      </MasterLayout>

    </>
  );
};

export default AllBookingPage; 
